/**
 * Custom Fields API client.
 * Thin axios wrapper — token is already attached globally by AuthContext.
 */
import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/custom-fields`;

export const customFieldsApi = {
  listDoctypes: () => axios.get(`${BASE}/doctypes`),
  list: (params = {}) => axios.get(BASE, { params }),
  get: (fieldId) => axios.get(`${BASE}/${fieldId}`),
  create: (payload) => axios.post(BASE, payload),
  update: (fieldId, payload) => axios.put(`${BASE}/${fieldId}`, payload),
  delete: (fieldId) => axios.delete(`${BASE}/${fieldId}`),
};

export default customFieldsApi;
